import dayjs from 'dayjs'
import { Enum } from 'enum-plus'
import { create } from 'lodash'

export const DateRangeGroupEnum = create(Enum({
    /**
     * 今天
     */
    Today: { label: '今天', value: 'Today' },
    Week: { label: '近7天', value: 'Week' },
    Month: { label: '本月', value: 'Month' },
    Custom: { label: '自定义', value: 'Custom' }
}), {
    getDatePresetRange: function({
        type,
        dateFormatScheme = 'YYYY-MM-DD',
        startFieldKey = 'startDate',
        endFieldKey = 'endDate'
    }) {
        // 根据类型执行相应的筛选逻辑
        const left = new Date()
        const right = new Date()
        switch (type) {
            case DateRangeGroupEnum.Today:
                // 处理今天的数据
                left.setHours(0, 0, 0, 0)
                right.setHours(23, 59, 59, 999)
                break
            case DateRangeGroupEnum.Week:
                // 处理近7天的数据
                left.setDate(left.getDate() - 6)
                left.setHours(0, 0, 0, 0)
                right.setHours(23, 59, 59, 999)
                break
            case DateRangeGroupEnum.Month:
                // 处理本月的数据
                left.setDate(1)
                left.setHours(0, 0, 0, 0)
                right.setHours(23, 59, 59, 999)
                break
            default:
                break
        }
        return {
            [startFieldKey]: dayjs(left).format(dateFormatScheme),
            [endFieldKey]: dayjs(right).format(dateFormatScheme)
        }
    }
})

export const ShiftTypeEnum = Enum({
    DayShift: { label: '白班', value: 0 },
    NightShift: { label: '夜班', value: 1 }
})

export enum PriceTypeEnum {
    PerHour = '0',
    FixedAmount = '1',
}

export const PriceTypeDataset = [
    {
        label: '按小时',
        value: PriceTypeEnum.PerHour,
        key: 'PerHour'
    },
    {
        label: '固定金额',
        value: PriceTypeEnum.FixedAmount,
        key: 'FixedAmount'
    }
]

export enum CalculateTypeEnum {
    PerWorkHour = '0',
    PerWorkTime = '1',
}

export const CalculateTypeDataset = [
    {
        label: '按工时',
        value: CalculateTypeEnum.PerWorkHour,
        tip: '按照员工最早一次打卡时间和最后一次打卡时间计算工时。',
        disabled: false
    },
    {
        label: '按上下班',
        value: CalculateTypeEnum.PerWorkTime,
        tip: '迟到、早退人员系统会特别标注，但不参与计算薪资。',
        disabled: false
    }
]

export enum RoundTypeEnum {
    Flexible = '0',
    Precise = '2',
}

export const RoundTypeDataset = [
    {
        label: '灵活计算',
        value: RoundTypeEnum.Flexible
    },
    {
        label: '精确计算',
        value: RoundTypeEnum.Precise,
        tip: '按精确工时 × 工价计算 '
    }
]

export const HalfUnitEnum = {
    Half: 0.5,
    One: 1
}

export const HalfUnitDataset = [
    {
        label: '0.5',
        value: HalfUnitEnum.Half
    },

    {
        label: '1',
        value: HalfUnitEnum.One
    }
]

export enum WorkHourLimitTypeEnum {
    Integer = '0',
    Subtract = '1'
}

export enum WorkNextDayEnum {
    No = '0',
    Yes = '1'
}
export const WorkNextDayDataset = [
    {
        label: '当日',
        value: WorkNextDayEnum.No
    },
    {
        label: '次日',
        value: WorkNextDayEnum.Yes
    }
]

// 添加数字转汉字函数
export function toChineseNum(num: number) {
    if (num === 0) return '零'

    const chineseNums = ['', '一', '二', '三', '四', '五', '六', '七', '八', '九']
    const units = ['', '十', '百', '千']

    let result = ''
    let digitPos = 0

    while (num > 0) {
        const digit = num % 10
        if (digit !== 0) {
            result = chineseNums[digit] + units[digitPos] + result
        } else if (result.length > 0 && result[0] !== '零') {
            result = '零' + result
        }
        num = Math.floor(num / 10)
        digitPos++
    }

    // 处理特殊情况
    return result
        .replace(/一十/g, '十') // 10 → 十
        .replace(/零+/g, '零') // 连续零 → 单个零
        .replace(/零+$/, '') // 末尾零 → 去掉
}
